import {
  CACHE_VEHICLE_MAKES,
  CACHE_VEHICLE_YEARS,
  CACHE_VEHICLE_MODELS,
  CACHE_VEHICLE_TRIMS,
  CACHE_VEHICLE_PRICES,
  CLEAR_VEHICLE_CACHE,
} from '../reducers/vehicleCacheReducer';

// 5 minute TTL
const DEFAULT_TTL = 5 * 60 * 1000;

export const generateCacheKey = (serviceType, params) => {
  const sortedParams = Object.keys(params || {})
    .sort()
    .reduce((result, key) => {
      result[key] = params[key];
      return result;
    }, {});

  return `${serviceType}:${JSON.stringify(sortedParams)}`;
};

const createCacheAction =
  (type) =>
  (cacheKey, data, timestamp = Date.now(), ttl = DEFAULT_TTL) => ({
    type,
    cacheKey,
    data,
    timestamp,
    ttl,
  });
export const cacheVehicleMakes = createCacheAction(CACHE_VEHICLE_MAKES);
export const cacheVehicleYears = createCacheAction(CACHE_VEHICLE_YEARS);
export const cacheVehicleModels = createCacheAction(CACHE_VEHICLE_MODELS);
export const cacheVehicleTrims = createCacheAction(CACHE_VEHICLE_TRIMS);
export const cacheVehiclePrices = createCacheAction(CACHE_VEHICLE_PRICES);

export const clearVehicleCache = () => ({
  type: CLEAR_VEHICLE_CACHE,
});
